import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getData, getStatus, getErrorMessage } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiStatuses, apiUrls } from "@/store/api/constants";

export default function useCityMaster() {
  const [isCreateEditModalOpen, setIsCreateEditModalOpen] = useState(false);
  const [activeEditId, setActiveEditId] = useState(0);
  const { formatMessage } = useIntl();

  const dispatch = useDispatch();
  const state = useSelector((store) => store);

  const cityMasterData = getData(state, apiKeys.cityMaster, []);
  const saveCityMasterStatus = getStatus(state, apiKeys.saveCityMaster, '');
  const updateCityMasterStatus = getStatus(state, apiKeys.updateCityMaster, '');
  const cityMasterStatus = getStatus(state, apiKeys.cityMaster, '');
  const cityMasterErrMsg = getErrorMessage(state, apiKeys.cityMaster, '');
  const deleteCityMasterStatus = getStatus(state, apiKeys.deleteCityMaster, '');

  const getCityMaster = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.cityMaster,
      method: apiMethods.GET,
      key: apiKeys.cityMaster,
      failureMsg: formatMessage({ id: "failed-to-get-city-master" }),
    }))
  }, [dispatch, formatMessage])

  useEffect(() => {
    getCityMaster()
  }, [dispatch, getCityMaster]);

  useEffect(() => {
    if (deleteCityMasterStatus === apiStatuses.succeeded) {
      getCityMaster();
    }
  }, [deleteCityMasterStatus, getCityMaster])

  useEffect(() => () => {
    dispatch(clearData({ key: [apiKeys.cityMaster, apiKeys.saveCityMaster, 
      apiKeys.updateCityMaster] }));
  }, [dispatch]);

  const onRowEdit = useCallback((id) => {
    setIsCreateEditModalOpen(true);
    setActiveEditId(id);
  }, [])
  const closeModal = useCallback(() => {
    setIsCreateEditModalOpen(false);
    setActiveEditId(0);
  }, []);

  useEffect(() => {
    if (saveCityMasterStatus === apiStatuses.succeeded) {
      closeModal(); 
      getCityMaster();
    } 
  }, [saveCityMasterStatus, closeModal, getCityMaster]);

  useEffect(() => {
    if (updateCityMasterStatus === apiStatuses.succeeded) {
      closeModal(); 
      getCityMaster();
    } 
  }, [updateCityMasterStatus, closeModal, getCityMaster]);

  return useMemo(() => ({
    cityMasterData,
    cityMasterStatus,
    cityMasterErrMsg,
    isCreateEditModalOpen,
    setIsCreateEditModalOpen,
    onRowEdit,
    activeEditId,
    closeModal
  }), [
    cityMasterData,
    cityMasterStatus,
    cityMasterErrMsg,
    isCreateEditModalOpen,
    setIsCreateEditModalOpen,
    onRowEdit,
    activeEditId,
    closeModal
  ])
}
